import { Route } from 'vue-router'

import BlankComponent from '@/ui/components/BlankComponent.vue'

export default {
  path: 'plants',
  // props: true,
  // meta: { showDialog: true },
  // component: () => import('@/ui/components/plants/PlantsInfoCard.vue'),
  component: BlankComponent,
  children: [
    {
      path: ':plantId?',
      name: 'garden/info',
      redirect: (to: Route) =>
        Object.assign({}, to, { name: 'garden/info/dashboard' }),
      props: true,
      component: () => import('@/ui/components/plants/PlantInfo.vue'),
      children: [
        {
          path: '',
          name: 'garden/info/dashboard',
          props: true,
          meta: { showDialog: true },
          component: () =>
            import('@/ui/components/plants/dashboard/PlantInfoDashboard.vue'),
        },
        {
          path: 'harvests',
          // name: 'garden/info/harvests',
          props: true,
          meta: { showDialog: true },
          component: () =>
            import('@/ui/components/plants/fragments/PlantHarvests.vue'),
          children: [
            {
              path: '/',
              props: {
                scrollable: true,
              },
              component: () => import('@/ui/components/DialogGeneric.vue'),
              children: [
                {
                  path: ':harvestId/edit',
                  name: 'garden/info/harvests/edit',
                  props: true,
                  meta: { showDialog: true },
                  component: () => import('@/ui/components/EditHarvest.vue'),
                },
              ],
            },
            {
              path: 'table/:harvestId?',
              name: 'garden/info/harvests',
              props: true,
              meta: { showDialog: true },
              component: () =>
                import('@/ui/components/harvests/HarvestsDataTable.vue'),
            },
            {
              path: 'table-dates/:harvestId?',
              name: 'garden/info/harvests/dates',
              props: true,
              meta: { showDialog: true },
              component: () =>
                import('@/ui/components/harvests/HarvestsDatesDataTable.vue'),
            },
            {
              path: 'calendar/:harvestId?',
              name: 'garden/info/harvests/calendar',
              props: true,
              // meta: { showDialog: true },
              component: () =>
                import('@/ui/components/harvests/HarvestsCalendar.vue'),
            },
            {
              path: 'calendar-weekly/:harvestId?',
              name: 'garden/info/harvests/calendar-weekly',
              props: true,
              // meta: { showDialog: true },
              component: () =>
                import('@/ui/components/harvests/HarvestsWeeklyCalendar.vue'),
            },
          ],
        },
        {
          path: 'timeline',
          name: 'garden/info/timeline',
          props: true,
          meta: { showDialog: true },
          component: () =>
            import('@/ui/components/plants/fragments/PlantTimeline.vue'),
        },
        {
          path: 'images',
          // name: 'garden/info/images',
          props: true,
          meta: { showDialog: true },
          component: () =>
            import('@/ui/components/plants/fragments/PlantImageGallery.vue'),
          children: [
            {
              path: ':imageId?',
              name: 'garden/info/images',
              props: true,
              meta: { showDialog: true },
              component: () => import('@/ui/controls/JImageGallery.vue'),
            },
          ],
        },
        {
          path: 'detail',
          name: 'garden/info/detail',
          props: true,
          meta: { showDialog: true },
          component: () => import('@/ui/components/plants/PlantInfoDetail.vue'),
        },
        {
          path: 'uploadavatar',
          name: 'garden/info/uploadavatar',
          props: true,
          meta: { showDialog: true },
          component: () =>
            import('@/ui/components/plants/fragments/PlantUploadAvatar.vue'),
        },
      ],
    },
  ],
}
